import { OnlineContactDetails, } from "./OnlineContactDetails";
import { QrWaiterContactDetails, } from "./QrWaiterContactDetails";
import { VoiceOrderContactDetails, } from "./VoiceOrderContactDetails";
export const ContactDetails = {
    empty(params) {
        if (params.isVoiceOrder) {
            return VoiceOrderContactDetails.empty(params.validatePhoneService, params.contactDetailsLock);
        }
        return params.isQrWaiterOrder
            ? QrWaiterContactDetails.empty(params.contactDetailsLock)
            : OnlineContactDetails.empty(params.validatePhoneService, params.contactDetailsLock);
    },
    fromStorageData({ validatePhoneService, contactDetailsLock, storageData, }) {
        switch (storageData.type) {
            case "Online":
                return OnlineContactDetails.fromStorageData({
                    validatePhoneService,
                    contactDetailsLock,
                    storageData,
                });
            case "QrWaiter":
                return QrWaiterContactDetails.fromStorageData(contactDetailsLock, storageData);
            case "VoiceOrder":
                return VoiceOrderContactDetails.fromStorageData({
                    validatePhoneService,
                    contactDetailsLock,
                    storageData,
                });
        }
    },
};
export const ContactDetailsToken = "ContactDetails";
